export class Control {
  value : any
}
